<template>
  <div :class="$style.container">
    <pusher-event-handlers
      :recipient="recipient"
      @received="handleReceived"
      @sent="handleSent"
      @delivered="handleDelivered"
      @failed="handleFailed"
      @undelivered="handleFailed" />
    <div :class="$style.messagesContainer" ref="messagesContainer">
      <div :class="$style.messages">
        <message
          v-for="activity in activities"
          :activity="activity"
          @resend="resendMessage"
          :class="$style.message"
          :key="activity.id" />
      </div>
    </div>
    <div :class="$style.inputContainer">
      <emoji-input
        ref="emojiInput"
        placeholder="Write text"
        v-model="message"
        :focus="true"
        :class="[$style.input, {[$style.inputDisabled]: isSending}]" />
      <button
        @click="sendMessage"
        :disabled="!message || isSending"
        :class="$style.sendButton"><font-awesome-icon :icon="faArrowUp" /></button>
    </div>
  </div>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp'
  import axios from 'axios'
  import { jiminnyHost } from '@/helpers/region'
  import Message from './message/message'
  import EmojiInput from 'vue-components/emoji-input/emoji-input'
  import PusherEventHandlers from './pusher-event-handlers/pusher-event-handlers'
  import * as Notifications from './notifications'

  export default {
    components: {
      FontAwesomeIcon,
      Message,
      EmojiInput,
      PusherEventHandlers
    },
    props: [
      'recipient',
      'prospectId',
      'objectType',
      'deviceId'
    ],
    data () {
      return {
        faArrowUp,
        isSending: false,
        activities: [],
        baseSMSEndpoint: `${jiminnyHost()}/api/v1/sms`,
        message: ''
      }
    },
    created () {
      this.retrieveAll()
    },
    methods: {
      retrieveAll () {
        axios
          .get(`${this.baseSMSEndpoint}/${encodeURIComponent(this.recipient)}`, {
            params: {
              prospectId: this.prospectId,
              objectType: this.objectType
            }
          })
          .then(response => (this.activities = response.data))
          .catch(console.error)
      },
      sendMessage () {
        const message = this.message

        if (message === '') {
          return
        }

        this.isSending = true

        axios
          .post(this.baseSMSEndpoint, {
            to: this.recipient,
            message,
            prospectId: this.prospectId,
            objectType: this.objectType,
            deviceId: this.deviceId
          })
          .then(() => {
            this.message = ''
            this.isSending = false
            this.$refs.emojiInput.focusEditor();
          })
          .catch(error => {
            const { status, data } = error.response

            let message = 'Something went wrong. Please try again or contact customer support.'

            if (data.errors && Array.isArray(data.errors.message)) {
              message = data.errors.message[0]
            } else if (status === 400 && data.error) {
              message = data.error.message
            }

            this.isSending = false
            Notifications.errorNotification({ message }).show()
          })
      },
      resendMessage (activity) {
        axios
          .put(`${this.baseSMSEndpoint}/${activity.id}`)
          .catch(error => {
            this.replaceActivity(activity)
            Notifications.errorNotification({ message: error.response.data.error.message }).show()
          })
      },
      scrollToBottom () {
        const el = this.$refs.messagesContainer
        el.scrollTop = el.scrollHeight - el.clientHeight
      },
      handleReceived (activity) {
        this.addActivity(activity)
      },
      handleSent (activity) {
        if (!this.isResent(activity)) {
          this.addActivity(activity)
        }
      },
      handleDelivered (activity) {
        this.replaceActivity(activity)
      },
      handleFailed (activity) {
        this.replaceActivity(activity)
      },
      isResent (activity) {
        return this.activities.some(a => a.id === activity.id)
      },
      addActivity (activity) {
        this.activities.push(activity)
      },
      replaceActivity (activity) {
        const index = this.activities.findIndex(a => a.id === activity.id)
        this.activities.splice(index, 1, activity)
      },
      handleError (error) {
        Notifications.errorNotification({ message: error }).show()
      }
    },
    mounted () {
      this.scrollToBottom()
    },
    watch: {
      activities () {
        // wait for message to be inserted into the DOM
        this.$nextTick(this.scrollToBottom)
      }
    }
  }
</script>

<style module lang="less" src="./sms-window.less"></style>



// WEBPACK FOOTER //
// sms-window.vue?fb35f432